/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import * as _ from 'lodash';

import {LayoutExampleCopyModalComponent, LayoutExampleCopySelectionResult} from './layout-example-copy-modal.component';
import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {AngularModalService} from '../../common/modal/angular-modal.service';
import {handleCopyModalResult} from '../../common/util/handle-copy-modal-result';
import {LayoutModel} from './layout-api.service';

@Component({
  standalone: false,
  selector: 'adn-layout-context-route-page',
  template: `
    @if (state) {
      <adn-signal-admin-resource-context-actions [state]="state"></adn-signal-admin-resource-context-actions>
      @if (!state.isNew() && !state.readOnly()) {
      <a
         class="btn btn-default btn-xs"
         style="margin-left: 5px"
         (click)="copyFromLayoutExample()">
        <span class="fa fa-fw fa-copy"></span>Copy from Layout Example
      </a>
      }
    }
  `
})
export class LayoutContextRoutePageComponent {
  @Input() state: SignalAdminResourcePageState<LayoutModel>;

  constructor(
    private readonly angularModalService: AngularModalService
  ) {
  }

  copyFromLayoutExample(): void {
    if (!this.state?.model()) {
      return;
    }

    const modalRef = this.angularModalService.show(LayoutExampleCopyModalComponent, {
      initialState: {model: this.state.model()}
    });

    (modalRef.content as LayoutExampleCopyModalComponent).onCopied.subscribe((result: LayoutExampleCopySelectionResult) => {
      handleCopyModalResult(() => {
        const updatedModel = {...this.state.model()};
        if (result.copyName) {
          updatedModel.name = result.layoutExample.name;
        }
        if (result.copyDescription) {
          updatedModel.description = result.layoutExample.description;
        }
        updatedModel.layoutComponents = _.cloneDeep(result.layoutExample.layoutComponents);
        updatedModel.layoutType = result.layoutExample.layoutType;
        updatedModel.renderTemplate = result.layoutExample.renderTemplate;
        this.state.replaceForEditing(updatedModel);
      });
    });
  }
}
